/*
 *
 * Package: `@dbh/tappable-hotel-card-theme`.
 *
 */const THEME_KEY_TAPPABLE_HOTEL_CARD="tappableHotelCard";const modifyTappableHotelCardTheme=a=>{let{colors:{greyLight:b}}=a;return {[THEME_KEY_TAPPABLE_HOTEL_CARD]:{sm:{boxShadow:"none"},md:{boxShadow:"0px 1px 6px "+b}}}};

export { THEME_KEY_TAPPABLE_HOTEL_CARD, modifyTappableHotelCardTheme as default };
